import { Component } from '@angular/core';

@Component({
  selector: 'app-family-forgot-password',
  templateUrl: './family-forgot-password.component.html',
  standalone: false,
})
export class FamilyForgotPasswordComponent {}
